import React from 'react'
import AvatarInputComponent from 'components/AvatarInput/AvatarInputComponent'

export default function UploadScreen() {
  return <AvatarInputComponent name="avatar_id" />
}
